import { render, staticRenderFns } from "./conversation-list-item.vue?vue&type=template&id=53415114&scoped=true&"
import script from "./conversation-list-item.vue?vue&type=script&lang=js&"
export * from "./conversation-list-item.vue?vue&type=script&lang=js&"
import style0 from "./conversation-list-item.vue?vue&type=style&index=0&id=53415114&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53415114",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAvatar,VChip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53415114')) {
      api.createRecord('53415114', component.options)
    } else {
      api.reload('53415114', component.options)
    }
    module.hot.accept("./conversation-list-item.vue?vue&type=template&id=53415114&scoped=true&", function () {
      api.rerender('53415114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/conversation-list-item/conversation-list-item.vue"
export default component.exports